import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";
import { Container } from "react-bootstrap";
import Table from "react-bootstrap/Table";
import { selectUser } from "../auth/authSlice";
import { updateSurveyRequest } from "../usersurveyrequest/surveyRequestSlice";
import {
  allocateSurvey,
  selectAllocatedMessage,
} from "../allocatesurvey/allocateSurveySlice";
import { Form } from "react-bootstrap";

export const SurveyRequestModal = (props) => {
  const dispatch = useDispatch();
  const allocatedSuccess = useSelector(selectAllocatedMessage);
  const user = useSelector(selectUser);
  const [updatedRecord, setUpdatedRecord] = useState([]);
  const surveys = props.surveys;

  const [searchTerm, setSearchTerm] = useState("");
  const [activeTab, setActiveTab] = useState("PENDING");

  const tabs = ["PENDING", "ACCEPTED", "REJECTED"];

  const business_admin = user?.groups?.includes("BUSINESS_ADMINS");


  const handlerAcceptSurveyRequest = async (record) => {
    const updatedRecord = {
      ...record,
      approver: user.username,
      sr_status: "ACCEPTED",
    };
    setUpdatedRecord(updatedRecord);

    await dispatch(
      allocateSurvey(
        record.requested_by,
        record.PK.slice(7),
        record.survey_title
      )
    );
    dispatch(updateSurveyRequest(updatedRecord));
  };

  const handlerRejectSurveyRequest = (record) => {
    const updatedRecord = {
      ...record,
      rejected: user.username,
      sr_status: "REJECTED",
    };
    dispatch(updateSurveyRequest(updatedRecord));
  };

  return (
    <Modal {...props} aria-labelledby="contained-modal-title-vcenter" size="xl">
      <Modal.Header closeButton>
        <Modal.Title id="contained-modal-title-vcenter">
          Survey Requests
        </Modal.Title>
      </Modal.Header>
      <Modal.Body className="grid-example">
        <Container>
        <div className="d-flex mb-4">
  {tabs.map((tab, index) => {
    const getButtonVariant = () => {
      if (tab === "PENDING") return "info";
      if (tab === "ACCEPTED") return "success";
      if (tab === "REJECTED") return "danger";
      return "secondary";
    };

    return (
      <Button
        key={tab}
        variant={getButtonVariant()}
        onClick={() => setActiveTab(tab)}
        className={`me-2 ${activeTab !== tab ? "opacity-50" : ""}`}
      >
        {tab}
      </Button>
    );
  })}
</div>


          <Form.Control
            type="text"
            placeholder="Search by Survey Title"
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            style={{ maxWidth: "300px", marginBottom: "1rem" }}
          />

          <Table striped bordered hover>
            <thead>
              <tr>
                <th>Survey Title</th>
                <th>Request Date</th>
                <th>Sent To</th>
                <th>Requested By</th>
                {activeTab === "PENDING" && business_admin && (
                  <th>Actions</th>
                )}
                {/* <th>Status</th> */}
                <th>Reviewer</th>
                {/* <th>Rejected By</th> */}
              </tr>
            </thead>
            <tbody>
              {surveys?.length > 0 ? (
                surveys
                  .filter(
                    (recordRow) =>
                      recordRow.sr_status === activeTab &&
                      recordRow.survey_title
                        ?.toLowerCase()
                        .includes(searchTerm.toLowerCase())
                  )
                  .map((recordRow, key) => (
                    <tr key={key}>
                      <td>{recordRow.survey_title || "No survey available"}</td>
                      <td>{recordRow.requested_date || "No date available"}</td>
                      <td>
                        {recordRow.admins_requested || "No admin available"}
                      </td>
                      <td>
                        {recordRow.SK?.replace("USER#", "") ||
                          "No user available"}
                      </td>

                      {/* Conditionally render action buttons only for PENDING + admin */}
                      {activeTab === "PENDING" && business_admin && (
                        <td>
                          <div className="d-flex mb-4">
                          <Button
                            variant="success"
                            onClick={() => {
                              props.onHide();
                              handlerAcceptSurveyRequest(recordRow);
                            }}
                          >
                            Accept
                          </Button>{" "}
                          <Button
                            variant="danger"
                            onClick={() => {
                              props.onHide();
                              handlerRejectSurveyRequest(recordRow);
                            }}
                          >
                            Reject
                          </Button>
                          </div>
                        </td>
                        
                      )}

                      {/* <td>{recordRow.sr_status || "Not available"}</td> */}
                      <td>{recordRow.approver || recordRow.rejector}</td>
                      {/* <td>{recordRow.rejector || "Not available"}</td> */}
                    </tr>
                  ))
              ) : (
                <tr>
                  <td colSpan="8" className="text-center">
                    No survey records available.
                  </td>
                </tr>
              )}
            </tbody>
          </Table>
        </Container>
      </Modal.Body>
      <Modal.Footer>
        <Button onClick={props.onHide}>Close</Button>
      </Modal.Footer>
    </Modal>
  );
};

export default SurveyRequestModal;
